import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import Seo from "../components/Seo";
import { PageHero } from "../components/common/Section";
import EnquiryForm from "../components/forms/EnquiryForm";
import CallbackForm from "../components/forms/CallbackForm";
import { whatsappLink } from "../components/layout/WhatsAppButton";
import { useSettings } from "../context/SettingsContext";

export default function Contact() {
  const { settings: s } = useSettings();
  const items = [
    { icon: Mail, label: "Email", value: s?.contact_email, href: `mailto:${s?.contact_email}` },
    { icon: Phone, label: "Phone", value: s?.contact_phone, href: `tel:${(s?.contact_phone || "").replace(/\s/g, "")}` },
    { icon: MessageCircle, label: "WhatsApp", value: "Chat with us", href: whatsappLink(s?.whatsapp_number) },
    { icon: MapPin, label: "Office", value: s?.address },
  ];
  return (
    <>
      <Seo title="Contact Us" path="/contact" />
      <PageHero eyebrow="Contact Us" title="Let's talk about your financial future." text="Send us a message, request a callback, or reach us on WhatsApp." />
      <section className="bg-slate-100/70 py-20">
        <div className="container-q grid gap-10 lg:grid-cols-[1.4fr_1fr]">
          <div className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
            <h2 className="mb-8 text-2xl font-bold text-navy">Send an enquiry</h2>
            <EnquiryForm />
          </div>
          <div className="space-y-6">
            <div className="grid gap-4">
              {items.map((it) => (
                <a key={it.label} href={it.href} target={it.label === "WhatsApp" ? "_blank" : undefined} rel="noopener noreferrer" data-testid={`contact-${it.label.toLowerCase()}`}
                  className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 transition-[transform,box-shadow] hover:-translate-y-0.5 hover:shadow-lg">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy text-gold"><it.icon size={18} /></div>
                  <div><p className="text-xs uppercase tracking-wider text-slate-500">{it.label}</p><p className="font-semibold text-navy">{it.value}</p></div>
                </a>
              ))}
            </div>
            <div className="rounded-[2rem] bg-navy p-8">
              <h3 className="text-lg font-semibold text-white">Request a callback</h3>
              <p className="mb-6 mt-1 text-sm text-slate-400">We'll call you at a time that suits you.</p>
              <CallbackForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
